var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExiticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0263 2.94812V4.99563L13.3388 3.69625V1.28125L12.6825 0.625H0.87L0.21375 1.28125V1.91913L0.1875 1.9375V15.4431L0.66 16.0469L7.2225 18.3044L8.0625 17.6875V16.375H12.6825L13.3388 15.7188V13.3431L12.0263 12.0306V15.0625H8.0625V4.18187L7.62937 3.57812L2.85975 1.9375H12.0263V2.94812ZM6.75 16.7425L1.5 14.9837V2.8825L6.75 4.64125V16.7425ZM15.3075 9.13H8.78438V7.8175H15.255L13.155 5.7175L14.0869 4.79875L17.3288 8.0275V8.95938L14.0606 12.2144L13.1419 11.2956L15.3075 9.13Z",
    fill: "#6ABC35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExiticon);
export default __webpack_public_path__ + "static/media/exiticon.f804c3b0efc837e06a102165af39d265.svg";
export { ForwardRef as ReactComponent };